export default __webpack_public_path__ + "static/about-436f2015deece188b2e1f2f336b47629.png";